import { FC } from "react";
import { HeaderContainer } from "./container";

export const Header: FC = () => {
  return <HeaderContainer />;
};
